
import AccountingReportingIndex from "./list.vue";
import AccountinginstallIndex from "./install.vue";
import Accountinglist from "./Accountinglist.vue"
import accountingDetail from "./accountingDetail.vue";
let a = Object.assign({
    AccountingReportingIndex,
    AccountinginstallIndex,
    Accountinglist,
    accountingDetail
})
export default a;